var React = require('react');

function CardLineInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1809 11C1638.83 -61 1505.57 293.693 1403.75 379.692C1293.71 472.625 1164.1 555.692 937.923 525.692C711.749 495.692 257 195.692 41 311.692C-51.8837 361.574 -99.6797 500.54 -159 484.532","stroke":"#E3000F","strokeOpacity":"0.2","strokeWidth":"2"}));
}

CardLineInline.defaultProps = {"width":"1728","height":"533","viewBox":"0 0 1728 533","fill":"none"};

module.exports = CardLineInline;

CardLineInline.default = CardLineInline;
